/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateApiAccountRequest
 */
export interface CreateApiAccountRequest {
    /**
     * 'sp' for serviceprovider-level access (all clients); 'client' for access scoped to a single client.
     */
    type: CreateApiAccountRequestTypeEnum;
    /**
     * Required when type is 'client'. UUID of the client this account should be scoped to.
     */
    clientUUID?: string;
}


/**
 * @export
 */
export const CreateApiAccountRequestTypeEnum = {
    Sp: 'sp',
    Client: 'client',
} as const;
export type CreateApiAccountRequestTypeEnum = typeof CreateApiAccountRequestTypeEnum[keyof typeof CreateApiAccountRequestTypeEnum];


/**
 * Check if a given object implements the CreateApiAccountRequest interface.
 */
export function instanceOfCreateApiAccountRequest(value: object): value is CreateApiAccountRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CreateApiAccountRequestFromJSON(json: any): CreateApiAccountRequest {
    return CreateApiAccountRequestFromJSONTyped(json, false);
}

export function CreateApiAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApiAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'clientUUID': json['clientUUID'] == null ? undefined : json['clientUUID'],
    };
}

export function CreateApiAccountRequestToJSON(json: any): CreateApiAccountRequest {
    return CreateApiAccountRequestToJSONTyped(json, false);
}

export function CreateApiAccountRequestToJSONTyped(value?: CreateApiAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'clientUUID': value['clientUUID'],
    };
}

